import { LEAVE_DASHBOARD } from '../../dashboard/Dashboard.actions';
import {
    APPROVED_DASHBOARD_READY,
    OUTSTANDING_DASHBOARD_READY,
    DASHBOARD_READY
} from './Dashboard.actions';
import {
    APPLY_REVENUE_BASED_LOAN_STATUS,
    APPROVAL_EXPIRED_STATUS,
    APPROVAL_INVALID_STATUS,
    APPROVED_STATUS,
    DECLINED_STATUS,
    DEFERRED_STATUS,
    OUTSTANDING_STATUS,
    PENDING_STATUS,
    UNKNOWN_STATUS
} from './Dashboard.helpers';

type RBLDashboardReadyAction = {
    type: typeof DASHBOARD_READY;
    status:
        | typeof APPROVED_STATUS
        | typeof DECLINED_STATUS
        | typeof DEFERRED_STATUS
        | typeof PENDING_STATUS
        | typeof OUTSTANDING_STATUS
        | typeof APPROVAL_EXPIRED_STATUS
        | typeof APPROVAL_INVALID_STATUS
        | typeof APPLY_REVENUE_BASED_LOAN_STATUS
        | typeof UNKNOWN_STATUS;
};

type RBLDashboardState = {
    ready: boolean;
    approvedReady: boolean;
    status:
        | typeof APPROVED_STATUS
        | typeof DECLINED_STATUS
        | typeof DEFERRED_STATUS
        | typeof PENDING_STATUS
        | typeof OUTSTANDING_STATUS
        | typeof APPROVAL_EXPIRED_STATUS
        | typeof APPROVAL_INVALID_STATUS
        | typeof APPLY_REVENUE_BASED_LOAN_STATUS
        | typeof UNKNOWN_STATUS;
    approvalRequirementsLoading: boolean;
    submitApplicationLoading: boolean;
};

const initialState = {
    ready: false,
    approvedReady: false,
    outstandingReady: false,
    status: UNKNOWN_STATUS,
    approvalRequirementsLoading: false,
    submitApplicationLoading: false
};

type RBLDashboardAction =
    | RBLDashboardReadyAction
    | { type: typeof APPROVED_DASHBOARD_READY }
    | { type: typeof OUTSTANDING_DASHBOARD_READY }
    | { type: typeof APPROVED_DASHBOARD_READY }
    | { type: typeof LEAVE_DASHBOARD };

// eslint-disable-next-line import/no-default-export
export default function (
    state: RBLDashboardState = initialState,
    action: RBLDashboardAction
) {
    switch (action.type) {
        case DASHBOARD_READY:
            const { status } = action;
            return {
                ...state,
                ready: true,
                status: status
            };
        case APPROVED_DASHBOARD_READY:
            return {
                ...state,
                approvedReady: true
            };
        case OUTSTANDING_DASHBOARD_READY:
            return {
                ...state,
                outstandingReady: true
            };
        case LEAVE_DASHBOARD:
            return initialState;
        default:
            return state;
    }
}
